<section class="error-page" aria-labelledby="error-title">
  <div class="error-content">
    <h1 id="error-title" class="error-title">Intermittent Technical Error</h1>
    <p class="error-subtitle" role="status" aria-live="polite" aria-atomic="true">
      This issue has been logged. You will be redirected in {{ secondsRemainingText() }}.
    </p>
    <a class="home-button" routerLink="/" [replaceUrl]="true">Return home now</a>
  </div>
</section>
